'use strict'

const cssVarNamePattern = '^[a-zA-Z0-9-_]+$'

const variableTypeFamilies = {
    NumVar: 'number',
    ColorVar: 'color',
    PercentageVar: 'percentage',
    OpacityVar: 'percentage'
}

// `supportedFunctions` is the contract surface for the impl-branch conformance test (follow-up PR)
const schemaValueTypeContracts = {
    'CSS.Color': {
        compoundSlotFamilies: ['number', 'percentage'],
        supportedFunctions: ['rgb', 'rgba']
    }
}

const COMPOUND_COMPATIBLE_SCHEMA_VALUE_TYPES = Object.keys(schemaValueTypeContracts)

/**
 * @param {string | undefined} schemaValueType
 * @returns {boolean}
 */
const isCompoundCompatibleSchemaValueType = schemaValueType =>
    Boolean(schemaValueType && COMPOUND_COMPATIBLE_SCHEMA_VALUE_TYPES.includes(schemaValueType))

/**
 * @param {string | undefined} schemaValueType
 * @returns {string[]}
 */
const compoundSlotRefTypesFor = schemaValueType => {
    if (!schemaValueType) return []
    const families = schemaValueTypeContracts[schemaValueType]?.compoundSlotFamilies
    if (!families) return []
    return Object.keys(variableTypeFamilies).filter(refType => families.includes(variableTypeFamilies[refType]))
}

function buildCompoundCompatibilityArtifact() {
    return {
        variableTypeFamilies,
        schemaValueTypeContracts,
        cssVarNamePattern
    }
}

module.exports = {
    buildCompoundCompatibilityArtifact,
    cssVarNamePattern,
    COMPOUND_COMPATIBLE_SCHEMA_VALUE_TYPES,
    isCompoundCompatibleSchemaValueType,
    compoundSlotRefTypesFor
}
